import { SidebarModal } from "@vega-core/components/Modals/SidebarModal/SidebarModal";

import { ModalSizeProvider, useModalSizeContext } from "./context";
import { Root } from "./Root";

type Props = {
  initialRoute?: string;
  onClose: VoidFunction;
  isOpen: boolean;
};

const PermissionsHelpModalContent = ({
  initialRoute,
  isOpen,
  onClose,
}: Props) => {
  const { isWide } = useModalSizeContext();

  return (
    <SidebarModal
      customWidthClassnames={isWide ? "w-full max-w-4xl" : undefined}
      dataTestId="permission-help"
      hideCloseButton
      isOpen={isOpen}
      noPadding
      noScrolling
      setIsOpen={onClose}
    >
      {isOpen ? (
        <div className="h-dvh">
          <Root
            initialRoute={initialRoute}
            key={initialRoute ?? "home"}
            onClose={onClose}
          />
        </div>
      ) : null}
    </SidebarModal>
  );
};

export const PermissionsHelpModal = (props: Props) => (
  <ModalSizeProvider>
    <PermissionsHelpModalContent {...props} />
  </ModalSizeProvider>
);
